// modules/dashboard/components/ComparativoComunidades.js
import { useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { ESTRATEGIA_INFO, REJILLA } from "../utils/colores";
import { num } from "./Piezas";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const TOP_GRAFICO = 15;

export default function ComparativoComunidades({ filas }) {
  const [verTodas, setVerTodas] = useState(false);
  const totalFila = (f) => ESTRATEGIA_INFO.reduce((a, e) => a + (f[e.clave] || 0), 0);
  const ordenadas = [...filas].sort((a, b) => totalFila(b) - totalFila(a));

  if (!ordenadas.length) {
    return <div className="db-vacio"><div>📍</div>Ningún registro con comunidad (con los filtros actuales).</div>;
  }

  const enGrafico = ordenadas.slice(0, TOP_GRAFICO);
  const data = {
    labels: enGrafico.map((f) => f.comunidad),
    datasets: ESTRATEGIA_INFO.map((e) => ({
      label: e.corto,
      data: enGrafico.map((f) => f[e.clave] || 0),
      backgroundColor: e.color,
      // Separación de 2px del color de la superficie entre segmentos apilados.
      borderColor: "#ffffff",
      borderWidth: { right: 2 },
      borderSkipped: false,
      barThickness: 16,
    })),
  };
  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top", align: "start", labels: { boxWidth: 10, boxHeight: 10, useBorderRadius: true, borderRadius: 2, font: { size: 11.5 } } },
      tooltip: { backgroundColor: "#12283f", padding: 10, cornerRadius: 8, mode: "index", intersect: false,
        filter: (item) => item.parsed.x > 0,
        footer: (items) => `Total: ${items.reduce((a, i) => a + i.parsed.x, 0)}` },
    },
    scales: {
      x: { stacked: true, beginAtZero: true, grid: { color: REJILLA, drawTicks: false }, border: { display: false }, ticks: { precision: 0, font: { size: 10.5 } } },
      y: { stacked: true, grid: { display: false }, border: { display: false }, ticks: { font: { size: 11 }, callback: (v, i) => { const t = enGrafico[i].comunidad; return t.length > 22 ? t.slice(0, 20) + "…" : t; } } },
    },
  };

  const totales = ESTRATEGIA_INFO.reduce((acc, e) => ({ ...acc, [e.clave]: ordenadas.reduce((a, f) => a + (f[e.clave] || 0), 0) }), {});
  const visibles = verTodas ? ordenadas : ordenadas.slice(0, 12);

  return (
    <div className="db-grid">
      <div className="db-tarjeta db-span-12">
        <h3>Personas caracterizadas por comunidad</h3>
        <div className="db-tarjeta-nota">
          {ordenadas.length > TOP_GRAFICO ? `Las ${TOP_GRAFICO} comunidades con más registros (de ${ordenadas.length})` : `${ordenadas.length} comunidades`} · apilado por estrategia
        </div>
        <div className="db-tarjeta-cuerpo" style={{ position: "relative", height: Math.max(180, enGrafico.length * 28 + 60) }}>
          <Bar data={data} options={options} role="img" aria-label="Personas por comunidad y estrategia" />
        </div>
      </div>

      <div className="db-span-12">
        <div className="db-tabla-wrap">
          <table className="db-tabla">
            <thead>
              <tr>
                <th>Comunidad</th>
                {ESTRATEGIA_INFO.map((e) => (
                  <th key={e.clave}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                      <i style={{ width: 8, height: 8, borderRadius: 2, background: e.color, display: "inline-block" }} />{e.corto}
                    </span>
                  </th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((f) => (
                <tr key={f.comunidad}>
                  <td>{f.comunidad}</td>
                  {ESTRATEGIA_INFO.map((e) => <td key={e.clave} className={f[e.clave] ? "" : "cero"}>{f[e.clave] || 0}</td>)}
                  <td><strong>{totalFila(f)}</strong></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>Total ({ordenadas.length} comunidades)</td>
                {ESTRATEGIA_INFO.map((e) => <td key={e.clave}>{num(totales[e.clave])}</td>)}
                <td>{num(Object.values(totales).reduce((a, b) => a + b, 0))}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        {ordenadas.length > 12 && (
          <div className="text-center mt-2 db-no-imprimir">
            <button type="button" className="db-limpiar" onClick={() => setVerTodas((v) => !v)}>
              {verTodas ? "Ver menos ▲" : `Ver las ${ordenadas.length} comunidades ▼`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
